<template>
    <div class="roles box">
        <div class="insert-role">
            <h2>{{ t('places-modules-title') }}</h2>
            <div class="form">
                <!-- i18n-validator-ignore-next-line: commented out code -->
                <!-- <input type="text" v-model="newRole" class="form-control" placeholder="Novo cargo" @keydown.enter="insert"> -->
            </div>
        </div>
        <table class="table table--list">
            <thead>
                <tr>
                    <th>{{ t('name') }}</th>
                    <th>{{ t('status') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <label for="checkedAll-input" class="form-check-label"
                            >{{ t('all') }}</label
                        >
                    </td>
                    <td>
                        <input
                            v-model="checkedAll"
                            @change="changeAll"
                            id="checkedAll-input"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                        />
                    </td>
                </tr>
                <tr v-for="(mod, key) in modules" :key="key">
                    <template v-if="placeModules[key]">
                        <td>
                            <label
                                :for="`check-input-${key}`"
                                class="form-check-label"
                                :class="{
                                    'text-muted': !placeModules[key].enabled,
                                }"
                                >{{ mod }}
                            </label>
                        </td>
                        <td>
                            <input
                                v-model="placeModules[key].enabled"
                                :id="`check-input-${key}`"
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                            />
                        </td>
                    </template>
                </tr>
            </tbody>
        </table>

        <div>
            <button
                class="btn btn-primary pull-right"
                :disabled="!isModifiedForm"
                @click.prevent="saveModules()"
            >
                {{ t('save') }}
            </button>
        </div>
        <div class="clear"></div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import keviApi from "../../../keviApi";
export default {
    computed: {
        ...mapState({
            placeId: (state) => state.placeDetails.id,
        }),
        isModifiedForm() {
            return (
                JSON.stringify(this.startPlaceModules) !==
                    JSON.stringify(this.placeModules) ||
                !this.placeModules.length
            );
        },
    },
    data() {
        return {
            checkedAll: false,
            modules: [],
            placeModules: [],
            startPlaceModules: [],
        };
    },
    watch: {
        placeModules: {
            deep: true,
            handler() {
                this.checkedAll = Object.values(this.placeModules)
                    .map((v) => v.enabled)
                    .every((v) => v);
            },
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        withModulesOutsideList(list = null, enabled = false) {
            list = JSON.parse(JSON.stringify(list));
            Object.keys(this.modules).forEach((key) => {
                if (!list.hasOwnProperty(key)) {
                    list[key] = {
                        enabled: enabled,
                        options: {},
                        places_id: this.placeId,
                        module: key,
                    };
                }
            });
            return list;
        },
        changeAll() {
            if (this.checkedAll) {
                return Object.keys(this.modules).forEach(
                    (k) => (this.placeModules[k].enabled = true),
                );
            }
            Object.keys(this.modules).forEach(
                (k) => (this.placeModules[k].enabled = false),
            );
        },
        getModulesList() {
            let options = keviApi.getOptions("places/modules", "GET");
            this.$http(options).then(
                (response) => (this.modules = response.body),
            );
        },
        getPlaceModules() {
            let options = keviApi.getOptions(
                `places/modules/${this.placeId}`,
                "GET",
            );
            this.$http(options).then((response) => {
                this.placeModules = this.withModulesOutsideList(response.body);
                this.startPlaceModules = JSON.parse(
                    JSON.stringify(this.placeModules),
                );
            });
        },
        saveModules() {
            let options = keviApi.getOptions(
                `places/modules/${this.placeId}`,
                "POST",
                {
                    modules: Object.assign({}, this.placeModules),
                },
            );
            this.$http(options).then(async (response) => {
                await this.updatePage();
                this.startPlaceModules = JSON.parse(
                    JSON.stringify(this.placeModules),
                );
                this.$store.dispatch(
                    "notification/success",
                    this.t('places-modules-updated'),
                );
            });
        },
        updatePage() {
            this.$router.push("/").catch(() => {});
            this.$router.push(`/place/${this.placeId}`);
            this.getPlaceModules();
        },
    },
    async beforeMount() {
        await this.getModulesList();
        await this.getPlaceModules();
    },
};
</script>
<style lang="less" scoped>
.insert-role {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.form-check-input,
.form-check-label {
    cursor: pointer;
}
</style>
